import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="typing-indicator"
// Auto-removes typing indicator after timeout
// Hides indicator if sender is the current user
export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 3000 },
    senderId: { type: Number, default: 0 }
  }

  connect() {
    // Hide if this is from the current user (don't show own typing indicator)
    const currentUserId = document.querySelector('meta[name="current-user-id"]')?.content
    if (currentUserId && this.senderIdValue && currentUserId === String(this.senderIdValue)) {
      this.element.remove()
      return
    }

    // Auto-remove after timeout
    this.timeout = setTimeout(() => {
      this.element.remove()
    }, this.timeoutValue)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
